import { inject, Pipe, PipeTransform } from '@angular/core';
import { catchError, map, Observable, of, startWith } from 'rxjs';
import { CountriesService } from '@shared-module/services/countries/countries.service';

/*
 * Resolves a country code to its name. Use it with the async pipe.
 * Shows the code itself while the list loads, or if the code is unknown.
 * Usage:
 *   {{ countryCode | countryName | async }}
 */
@Pipe({
  name: 'countryName',
})
export class CountryNamePipe implements PipeTransform {
  private readonly _countriesService = inject(CountriesService);

  transform(code: string | null | undefined): Observable<string> {
    if (!code) return of('');
    return this._countriesService.getCountries().pipe(
      map(
        countries =>
          countries.find(country => country.code === code)?.name ?? code
      ),
      catchError(() => of(code)),
      startWith(code)
    );
  }
}
